/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props<K> {
  children: ReactNode;
  ErrorComponent: React.ElementType;
  ErrorComponentProps: K;
}

interface State {
  hasError: boolean;
  error: Error;
}

class ErrorBoundary<K> extends Component<Props<K>, State> {
  public state: State = {
    hasError: false,
    error: Error()
  };

  public static getDerivedStateFromError (_: Error): State {
    return { hasError: true, error: _ };
  }

  public componentDidCatch (error: Error, errorInfo: ErrorInfo) {
    console.log('Uncaught error:', error, errorInfo);
  }

  public render () {
    const ErrorComponent = this.props.ErrorComponent;

    if (this.state.hasError) {
      return <ErrorComponent {...this.props.ErrorComponentProps} error={this.state.error}></ErrorComponent>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
